import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../../hooks/useApi";
import RadioBtn from "../../../../Button/RadioBtn";
import Blank from "../../../../DefaultStyles/Blank";
import Flex from "../../../../DefaultStyles/Flex";
import Loader from "../../../../DefaultStyles/Loader";
import { Input } from "../../../../Input/Input";
import AlertModal from "../../../../Modal/AlertModal";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import ManagerPwInputModal from "../../../../Modal/ManagerPwInputModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";

interface VersionUpdateModalProps extends DefaultModalCommonProps {
  isApp: boolean;
}

export default function VersionUpdateModal({
  isApp,
  closeEvent,
  confirmEvent,
}: VersionUpdateModalProps) {
  const [version, setVersion] = useState("");
  const [updateAskModal, setUpdateAskModal] = useState(false);
  const [pwInputModal, setPwInputModal] = useState(false);
  const [updateVersion, setUpdateVersion] = useState(false);

  const typeCheck = {
    app: isApp ? true : false,
    web: !isApp ? true : false,
  };

  const type = isApp ? "앱" : "웹";

  const { response, error, loading } = useApi({
    method: "post",
    url: updateVersion ? `version/version` : undefined,
    data: {
      isApp: isApp ? 1 : 0,
      latest_ver: version,
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      closeEvent();
      toast.success(`${type} 버전이 업데이트 되었습니다.`);
      if (confirmEvent) confirmEvent();
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(
        error?.data ?? `${type} 버전을 업데이트 하는 데에 실패하였습니다.`
      );
    }
  }, [error]);

  return (
    <>
      <DefaultModalLayout
        modalTitle="버전 관리"
        closeEvent={() => closeEvent()}
        confirmEvent={() => setUpdateAskModal(true)}
        isMediumModal={true}
        confirmBtnText="업데이트"
        confirmDisabled={version === ""}
      >
        <ModalLabel>구분</ModalLabel>

        <Blank blankHeight={10} />

        <Flex gapSize={70}>
          <RadioBtn
            label="앱"
            check={typeCheck?.app}
            clickEvent={() => {}}
            noTooltip={true}
            disabled={true}
          />

          <RadioBtn
            label="웹"
            check={typeCheck?.web}
            clickEvent={() => {}}
            noTooltip={true}
            disabled={true}
          />
        </Flex>

        <Blank blankHeight={40} />

        <ModalRow>
          <ModalLabel>버전</ModalLabel>

          <Input
            type="text"
            inputMode="decimal"
            value={version}
            onChange={(e) => setVersion(e.target.value)}
            placeholder="업데이트 버전을 입력해주세요."
          />
        </ModalRow>
      </DefaultModalLayout>

      {loading && <Loader />}

      {updateAskModal && (
        <AlertModal
          title={`${type}버전이 ${version}로 업데이트 됩니다.
        계속 하시겠습니까?`}
          confirmEvent={() => {
            setPwInputModal(true);
            setUpdateAskModal(false);
          }}
          cancelEvent={() => setUpdateAskModal(false)}
        />
      )}

      {pwInputModal && (
        <ManagerPwInputModal
          closeEvent={() => setPwInputModal(false)}
          confirmEvent={() => setUpdateVersion(true)}
        />
      )}
    </>
  );
}
